/**
 * Catálogo de tarifas por energía de la ficha del inmueble (ADS-0112,
 * corrección del 13/09/2026). Espejo de Supply::LIGHT_RATES / GAS_RATES en la
 * API. Las potencias contratadas P1-P6 solo aplican a la luz.
 */
export const LIGHT_RATES = ['2.0TD', '3.0TD', '6.1TD']

export const GAS_RATES = ['RL1', 'RL2', 'RL3', 'RL4', 'RL5', 'RL6']

export const POWER_PERIODS = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6']
